import { createSelector } from 'reselect';
import {
  getUserBirthdateSelector,
  getBirthdateBeforeFourteenAndHalfAgo,
  mainDataBirthRegPlaceSelector
} from '../mainData/selectors';
import {
  getUserBirthdateSelector as getChildBirthdateSelector,
  getBirthdateBeforeFourteenAndHalfAgo as getChildBirthdateBeforeFourteenAndHalfAgo,
  mainDataBirthRegPlaceSelector as childRegBirthPlaceSelector
} from '../mainDataChild/selectors';
import { passportDocumentTypeSelector } from '../passport/selectors';
import { passportDocumentTypeSelector as childDocumentTypeSelector } from '../passportChild/selectors';
import validator from '../../helpers/validator';
import { ACT_RECORD_FIELD_NAMES } from '../../constants/actRecord';
import { getActRecordVersionByDate } from '../../helpers/actRecord';
import { formatDateStringToISOString } from '../../helpers/date';
import {
  BIRTH_REG_PLACES_VALUES,
  DOCUMENT_TYPE
} from '../../constants/citizenship';
import { applicantTypeSelector } from '../applicant/selectors';
import { APPLICANT_TYPES } from '../../constants/applicant';
import { create } from '@mos-utils/acs-fetch';

export const actRecordSelector = state => state.actRecord;

export const actRecordDataSelector = createSelector(
  actRecordSelector,
  subState => ({ ...subState.data })
);

export const actRecordBlurSelector = createSelector(
  actRecordSelector,
  subState => subState.blur
);

export const actRecordRegPlaceNameSuggestionsSelector = createSelector(
  actRecordSelector,
  subState => subState.regPlaceNameSuggestions.list
);

export const actRecordRegPlaceNameSuggestionsFetchingSelector = createSelector(
  actRecordSelector,
  subState => subState.regPlaceNameSuggestions.fetching
);

export const actRecordRegPlaceNameSuggestionsFetchingErrorSelector = createSelector(
  actRecordSelector,
  subState => subState.regPlaceNameSuggestions.fetchingError
);

const combinedSelector = createSelector(
  applicantTypeSelector,
  actRecordDataSelector,
  getUserBirthdateSelector,
  getBirthdateBeforeFourteenAndHalfAgo,
  (
    applicantType,
    actRecordData,
    birthdate,
    birthdateBeforeFourteenAndHalfAgo
  ) => {
    return {
      applicantType,
      actRecordData,
      birthdate,
      birthdateBeforeFourteenAndHalfAgo
    };
  }
);

const secondCombinedSelector = createSelector(
  mainDataBirthRegPlaceSelector,
  getChildBirthdateSelector,
  getChildBirthdateBeforeFourteenAndHalfAgo,
  childRegBirthPlaceSelector,
  (
    birthRegPlace,
    childBirthdate,
    childBirthdateBeforeFourteenAndHalfAgo,
    childBirthRegPlace
  ) => {
    return {
      birthRegPlace,
      childBirthdate,
      childBirthdateBeforeFourteenAndHalfAgo,
      childBirthRegPlace
    };
  }
);

export const actRecordValidationSelector = createSelector(
  combinedSelector,
  secondCombinedSelector,
  passportDocumentTypeSelector,
  childDocumentTypeSelector,
  (data, data2, documentType, childDocumentType) => {
    const {
      applicantType,
      actRecordData,
      birthdate,
      birthdateBeforeFourteenAndHalfAgo
    } = data;
    const {
      birthRegPlace,
      childBirthdate,
      childBirthdateBeforeFourteenAndHalfAgo,
      childBirthRegPlace
    } = data2;
    const actRecordDate = actRecordData[ACT_RECORD_FIELD_NAMES.date].value;
    const actRecordVersion = getActRecordVersionByDate(actRecordDate);
    let currentBirthdate;
    let isValidationNeeded = false;

    if (applicantType === APPLICANT_TYPES.participant) {
      currentBirthdate = birthdate;
      isValidationNeeded =
        birthRegPlace === BIRTH_REG_PLACES_VALUES.RF &&
        documentType === DOCUMENT_TYPE.BIRTH_CERTIFICATE_RF &&
        birthdateBeforeFourteenAndHalfAgo;
    } else {
      currentBirthdate = childBirthdate;
      isValidationNeeded =
        childBirthRegPlace === BIRTH_REG_PLACES_VALUES.RF &&
        childDocumentType === DOCUMENT_TYPE.BIRTH_CERTIFICATE_RF &&
        childBirthdateBeforeFourteenAndHalfAgo;
    }

    if (isValidationNeeded) {
      return validator(
        {
          ...actRecordData,
          birthdate: currentBirthdate
        },
        'act_record',
        actRecordVersion,
        true
      );
    }

    return {
      valid: true
    };
  }
);

export const appealSubmitActRecordSelector = createSelector(
  actRecordDataSelector,
  subState => {
    const date = subState[ACT_RECORD_FIELD_NAMES.date].value;

    return {
      act_date: date ? formatDateStringToISOString(date) : '',
      act_number: subState[ACT_RECORD_FIELD_NAMES.number].value || '',
      reg_office_name:
        subState[ACT_RECORD_FIELD_NAMES.regPlace].value?.text || ''
    };
  }
);
